import React, { FC } from 'react';

import { Navigate } from 'react-router-dom';

import { useOTPIPCheck } from '@/components/hooks';
import appConfig from '@/config/env';
import { Loading } from '../../Common/Loading';
import OTPSignIn from './index';

/**
 * OTP sign-in entry. SPX-6391: when HIDE_LOGIN_WITH_CODE is set (Demo3/Migdal),
 * redirect to username+password login. Direct /OTPSignIn is not a release blocker
 * to gate by frequent-group identity (unknown before login); tenant flag is enough.
 */
const OTPSignInGuard: FC = () => {
    const ipCheckState = useOTPIPCheck();

    if (appConfig.HIDE_LOGIN_WITH_CODE) {
        return <Navigate to="/signIn" replace />;
    }

    if (ipCheckState === 'loading') {
        return <Loading fullScreen loadingText="Verifying access..." />;
    }

    if (ipCheckState === 'denied') {
        return <Navigate to="/signIn" replace />;
    }

    return <OTPSignIn />;
};

export default OTPSignInGuard;
